<template>
  <el-dialog
    title="领礼纪录"
    :visible.sync="visible"
    width="600px"
    append-to-body=""
    @closed="handleClosed">
    <p style="margin-bottom: 10px;">活动名称:<span style="margin-left: 10px;">{{ prizeInfo.activityName }}</span></p>
    <el-table
      v-loading="loading"
      border
      :data="list">
      <el-table-column
        label="领礼人"
        prop="userName"></el-table-column>
      <el-table-column
        label="联系方式"
        prop="mobilePhone"></el-table-column>
      <el-table-column label="中奖时间">
        <template slot-scope="{row}">
          <span>{{ row.createdTime | dateformat() }}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      style="text-align: center;"
      :current-page="config.pageNum"
      :page-size="config.pageSize"
      layout="total, prev, pager, next"
      :total="totalNum"
      @current-change="handleCurrentChange">
    </el-pagination>
    <div slot="footer">
      <el-button @click="toggleModal(false)">关 闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'WinningRecordsModal',
  components: {},
  props: {
    callback: Function
  },
  data() {
    return {
      loading: false,
      list: [],
      visible: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        scanCodeGiftId: null
      },
      totalNum: 0,
      prizeInfo: {}
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.list = []
    },
    handleCurrentChange(cur) {
      this.config.pageNum = cur
      this.fetchList()
    },
    fetchList(cb) {
      this.loading = true
      this.$store.dispatch('coupon/getscancodegiftrecords', {
        payload: {
          ...this.config
        },
        success: res => {
          this.loading = false
          this.totalNum = res.data.total
          this.list = res.data.records
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch(row) {
      this.prizeInfo = row
      this.config.scanCodeGiftId = row.scanCodeGiftId
      this.fetchList(() => {
        this.toggleModal(true)
      })
    }
  }
}
</script>
